// 组件全部使用的情报的， 这里页面先对studio这边能控制的部分做配置化（如显示隐藏，个别话术：如tips话术），情报的组件不做配置化改动
import React  from 'react';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import { PAGE_CONFIG } from './pcPageConfig';
import { ConfigProvider } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';

const Competitors = () => {
  const { locale } = useIntl();

  return (
    <ConfigProvider locale={locale === 'zh-CN' ? 'zh' : 'en'}>
      <CommonPageRender
        key={location.href}
        className={'dbh-studio-competitors'}
        reqParams={'/competitors'}
        frameType="game"
        // @ts-ignore
        pageConfigInit={PAGE_CONFIG}
        api={PAGE_CONFIG_API}
      />
    </ConfigProvider>
  );
};

export default Competitors;
